<template>
  <NuxtLink aria-label="Go back to the site homepage" class="brand" to="/">
    <Logo alt="Compass – Guiding Action on Elder Abuse" filled />
  </NuxtLink>
</template>

<script setup lang="ts">
import Logo from '~/assets/images/logo.svg'
</script>

<style lang="less" scoped>
.brand {
  .inline-block();

  @media @mobile-lg {
    margin-left: 0;
    align-self: center;
  }

  @media @tablet {
    margin-left: 0;
    align-self: center;
  }

  img,
  svg {
    // .block();

    height: @40px;
    width: @235px;
    vertical-align: middle;
    fill: @color-fill-normal;
    max-width: 100%;
  }

  img {
    object-fit: contain;
  }

  .brand__compass {
    fill: @color-secondary;
  }

  .brand__desc {
    fill: @color-fill-dark;
  }

  &.brand--small {
    img,
    svg {
      width: @155px;
      height: @66px;

      @media @tablet {
        width: @195px;
      }

      @media @wide {
        height: @40px;
        width: @220px;
      }
    }
  }
}
</style>
